import { FlaskConical } from "lucide-react";

/**
 * Label for pre-launch beta tester feedback.
 *
 * Beta testers received product before launch, so there is no purchase to
 * verify. They are never paid and are never asked for a particular rating.
 * Keeping this visually distinct from VerifiedPurchaseBadge is an honesty
 * requirement, not a style choice.
 */
export function BetaTesterBadge({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-[#2C2C2C]/8 px-2 py-0.5 text-[11px] font-medium normal-case tracking-normal text-[#2C2C2C]/75 ${className}`}
    >
      <FlaskConical size={12} strokeWidth={2.5} /> Beta tester
      <span className="font-normal text-[#2C2C2C]/55">· pre-launch trial</span>
    </span>
  );
}
